module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/truck-eb6c7edf42d43ce5f8127e62a2add263.svg";